// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsRemediation = {
  summaryRemediation: "Remediation items: {count}",
  summaryRemediationCritical: "Critical remediation: {count}",
  remediationPriorities: {
    warning: "Warning",
    critical: "Critical",
  },
  remediationCategories: {
    object_space: "Object space",
    reference: "Reference governance",
  },
  remediationActions: {
    enable_space_governance: "Enable object-space governance",
    reactivate_object_space: "Reactivate object space",
    review_readonly_space_policy: "Review read-only object-space policy",
    configure_space_grants: "Configure object-space grants",
    resolve_blocked_delete_assets: "Resolve delete-blocked assets",
    normalize_reference_scope: "Normalize reference scope",
    review_high_binding_references: "Review high-binding references",
    repair_reference_bindings: "Repair bindings without assets",
    normalize_reference_service: "Normalize service naming",
  },
  remediationReasons: {
    space_unmanaged: "Object space is unmanaged",
    space_disabled: "Object space is disabled",
    space_readonly: "Object space is read-only",
    space_no_grants: "Object space has no grants",
    space_has_delete_blocked_assets: "Object space contains delete-blocked assets",
    non_global_scope: "Reference scope is not normalized",
    high_binding_count: "Reference binding count is too high",
    binding_without_assets: "Binding exists without assets",
    service_not_normalized: "Service identifier is not normalized",
  },
} as const;
